<template>
  <div></div>
</template>
<script>
import ApplicationUserManager from '@/services/auth-service'

ApplicationUserManager.signinSilentCallback()
  // eslint-disable-next-line no-unused-vars
  .then((_) => ApplicationUserManager.refreshUserInfo())
  .catch((error) => {
    console.error(error)
  })

export default {
  name: 'SilentLogin',
}
</script>
